import http from "infra/http";
import { useMutation } from "react-query";

function useToggleAssembleiaStatus() {
  return useMutation(
    "/v1/votacao/mudar-status",
    async (params: { id: string; nextStatus: boolean }) =>
      http.put(
        `/v1/votacao/${params.id}/${params.nextStatus ? "ativar" : "desativar"}`
      )
  );
}

export default useToggleAssembleiaStatus;
